<template>
  <v-theme-provider :dark="dark">
    <v-container class="pa-0">
      <v-row :justify="justify" no-gutters>
        <v-col :class="text - align" cols="12" class="mb-4">
          <!-- <base-icon :color="color">
            {{ icon }}
          </base-icon> -->
        </v-col>

        <v-col class="grid" v-if="title || subtitle">
          <div class="grid">
            <v-img
              height="70px"
              width="100px"
              color="white"
              :src="callout"
              class="mb-n16"
              contain
            />
            <v-hover v-slot:default="{ hover }">
              <v-img
                :src="src"
                :size="size"
                height="100px"
                width="100px"
                space="1"
                class="ml-auto mr-auto"
                :class="{ 'zoom-efect': hover }"
              ></v-img>
            </v-hover>

            <base-subtitle
              class="text-center"
              v-if="subtitle"
              :title="subtitle"
              space="1"
            />

            <base-title
              color="rgb(34, 34, 34)"
              :title="title"
              class="text-uppercase text-center mb-n4"
              space="1"
            />

            <div>
              <base-divider class="ml-auto mr-auto my-3" :color="color" />
            </div>
            <base-body
              class="text-center black--text"
              color="black"
              :text="text"
              space="6"
            >
              <slot />
            </base-body>
          </div>
        </v-col>

        <!-- <v-col  cols="2" md="2">
          <div class="text-h2 black--text  font-weight-bold mr-6" color="black">
            <v-img
              height="70px"
              width="100px"
              color="white"
              :src="callout"
              contain
              class="mt-8 "
            />
          </div>
        </v-col> -->
      </v-row>
    </v-container>
  </v-theme-provider>
</template>

<script>
// Mixins
import Heading from '@/mixins/heading';

export default {
  name: 'BaseInfoCard',

  mixins: [Heading],

  props: {
    dark: Boolean,
    callout: String,
    color: {
      type: String,
      default: 'primary',
    },
    size: {
      type: [Number, String],
      default: 56,
    },
    icon: String,
    subtitle: String,
    text: String,
    title: String,
    src: String,
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  place-items: center;
}
/* .zoom-efect {
  transform: scale(1.1);
} */
</style>
